module.exports = __webpack_public_path__ + "static/media/fly0074.474f28ca.webp";